// start:react-app-polyfill
// these must be the first lines in src/index.js
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
// end:react-app-polyfill
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './app';
import { buildErrorLog, buildRejectionLog } from './helpers/global-error-handlers';
import { webLogPost } from './helpers/web-log';
import { store } from './store';

// Global uncaught error forwarding — fire-and-forget, disabled in local dev.
// Opaque cross-origin "Script error." events are dropped by buildErrorLog.
window.addEventListener('error', (event) => {
  const payload = buildErrorLog(event);
  if (payload) {
    webLogPost(payload);
  }
});

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const payload = buildRejectionLog(event);
  if (payload) {
    webLogPost(payload);
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('#root')
);
